import React, { useMemo, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";

export default function LGAutocompleteCellEditor({
  id,
  value,
  field,
  api,
  fetchFunction,
  getFetchParams,
  labelTemplate = (v) => v?.name ?? "",
  isOptionEqualToValue = (option, selected) => option?.id === selected?.id,
  queryParams = {},
}) {
  const [options, setOptions] = useState(value ? [value] : []);
  const [loading, setLoading] = useState(false);

  const debouncedFetch = useMemo(() => {
    let timeoutId;

    return (input) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(async () => {
        setLoading(true);
        try {
          const params = {
            ...(typeof getFetchParams === "function" ? getFetchParams(input) : {}),
            ...queryParams,
          };
          const response = await fetchFunction(params);
          const nextOptions = Array.isArray(response?.data)
            ? response.data
            : Array.isArray(response)
            ? response
            : [];
          setOptions(nextOptions);
        } catch (error) {
          console.error("Error fetching autocomplete options:", error);
          setOptions([]);
        } finally {
          setLoading(false);
        }
      }, 300);
    };
  }, [fetchFunction, getFetchParams, queryParams]);

  return (
    <Autocomplete
      autoHighlight
      fullWidth
      options={options}
      value={value ?? null}
      loading={loading}
      onInputChange={(_, inputValue) => {
        debouncedFetch(inputValue);
      }}
      getOptionLabel={(option) => labelTemplate(option)}
      isOptionEqualToValue={isOptionEqualToValue}
      onChange={(_, selectedOption) => {
        api.setEditCellValue({
          id,
          field,
          value: selectedOption,
          debounceMs: 200,
        });
      }}
      renderInput={(params) => <TextField {...params} autoFocus />}
    />
  );
}
